$(document).ready(function(){
	$(window).load(function(){

		// Global Variables
		var $pageHeight = $(window).height(),
		$pageWidth = $(window).width(),
		$navHeight = $('header.site-header').outerHeight(),
		$quickLinks = $('nav.site-quicklinks').outerHeight(),
		$footerHeight = $('footer.site-footer').outerHeight();
		gformsubmit();
		selectProductCategory();
		selectProductName();
		selectFilmType();

		$('.menu-container .menu-contain').css({
			'padding-bottom' : $quickLinks,
			'padding-top' : $navHeight
		});
		
		function selectProductCategory() {
			if ($('.category-template').attr("id") == "category-name-template") {
				var categoryName = $('#category-name-template').data('category-name');
				$('#input_3_6').val(categoryName).css({
					'background-image': 'none',
					'color' : '#303030'
				});
			}
			else if ($('.single-product-template').attr("id") == "category-name-single") {
				var categoryNameSingle = $('#category-name-single').data('category-name');
				$('#input_3_6').val(categoryNameSingle).css({
					'background-image': 'none',
					'color' : '#303030'
				});
			}
		}
		function selectProductName() {
			if ($('.brand-name').attr("id") == "product-title") {
				var productName = $('#product-title').data('product-name');
				$('#input_3_7').val(productName).css({
					'background-image': 'none',
					'color' : '#303030'
				});
			}
		}
		function selectFilmType() {
			// var brandID = $('.brand-type-film').data('brand-id');
			// var singleBrand = $('.product-image').data('id');
			// var typeFilm = $('#brand'+brandID).data('brand-film');
			// var singleBrandId = "singleBrand"+singleBrand;
			if ($('.product-content').data('film-name')) {
				var filmType = $('.product-content').data('film-name');
				$('#input_3_8').val(filmType).css({
					'background-image': 'none',
					'color' : '#303030'
				});
				// console.log(filmType);
			}
		}

		$(document).on('click', '.mobile-menu.notAnimated', function(){
			$('body, html').css({
				'overflow' : 'hidden'
			});

			$(this).removeClass('notAnimated').addClass('animated');
			$('.menu-container').addClass('show');
			setTimeout(function(){
				$('.menu-container').addClass('animate');
			}, 500);
		});

		$(document).on('click', '.mobile-menu.animated', function(){
			$(this).removeClass('animated').addClass('notAnimated');

			$('.menu-container').removeClass('animate');
			$('body, html').removeAttr('style');

			setTimeout(function(){
				$('.menu-container').removeClass('show');
			}, 500);

			setTimeout(function(){
				$('.menu-container .menu-contain nav ul li .sub-menu').removeClass('show');
			}, 700);

		});

		$(document).on('click', '.submenu-button', function(){
			$(this).parent('li').find(' > .sub-menu').addClass('show');
		});
		$(document).on('click', '.submenu-close-button', function(){
			$(this).parent('li').parent('ul').removeClass('show');
		});

		$(document).on('click', 'a[href^="mailto:"].main', function(e){
			e.preventDefault();
			$('body, html').css({
				'overflow' : 'hidden'
			});

			$('.mailto-container').addClass('show');
			setTimeout(function(){
				$('.mailto-container').addClass('animate');
			}, 300);
		});

		$(document).on('click', '.mailto-close-button', function(){
			$('.mailto-container').removeClass('animate');
			$('body, html').removeAttr('style');

			setTimeout(function(){
				$('.mailto-container').removeClass('show');
			}, 300);
		});

		$(document).on('click', '.search-btn', function(){
			$('body, html').css({
				'overflow' : 'hidden'
			});
			$('.search-form-template').addClass('show');
			setTimeout(function(){
				$('.search-form-template').addClass('animate');
			}, 300);
		});

		$(document).on('click', '.search-close-button', function(){
			$('body, html').removeAttr('style');
			$('.search-form-template').removeClass('show');
			setTimeout(function(){
				$('.search-form-template').removeClass('animate');
			}, 300);
		});

		$(document).on('click', '.testimonial-item-contain', function(){
			$.ajax({
				url : $('.ajaxlocation').data('ajaxlocation'),
				type : 'POST',
				dataType: 'json',
				data : {
					action : 'request_testimonial',
					id : $(this).data('id')
				},
				beforeSend: function(){
					$('body, html').css({
						'overflow' : 'hidden'
					});
					$('.popup-modal-container').addClass('show');
					$('html').addClass('popupshow');
				},
				success: function(response) {
					
					setTimeout(function(){
						$('.popup-modal-container').addClass('animate');
					}, 300);
					$('.popup-modal-container .popup-body').html(response.content);
			
				}
			});
		});

		$(document).on('click', '.popup-close', function(){
			$('body, html').removeAttr('style');
			$('header.site-header.push-top').removeAttr('style');
			$('.popup-modal-container').removeClass('show');
			$('html').removeClass('popupshow');
			setTimeout(function(){
				$('.popup-modal-container').removeClass('animate');
			}, 300);
		});


		$(document).on('click', '.apply-btn', function(e){
			var position = $(this).data('position');
			e.preventDefault();
			$('body, html').css({
				'overflow' : 'hidden'
			});

			$('.career-container .yourPosition input').val(position);
			$('.career-container').addClass('show');
			setTimeout(function(){
				$('.career-container').addClass('animate');
			}, 300);
		});

		$(document).on('click', '.career-close-button', function(){
			$('.career-container').removeClass('animate');
			$('body, html').removeAttr('style');

			setTimeout(function(){
				$('.career-container').removeClass('show');
			}, 300);
		});

		$(document).on('click', '#resumeBtn', function(){
			var input = $('.resume-container .resume input');
			input.click();
		});

		$('.resume-container .resume input').change(function(e){
			var FileName = e.target.files[0];
			$('#resumeBtn').addClass('active').text(FileName.name);
		});

		$(document).on('click', '.expand-term', function(e){
			e.preventDefault();
			$(this).toggleClass('fa-angle-down').toggleClass('fa-angle-up');
			$(this).parent('a').parent('.parent-term').find('.chid-term').first().toggleClass('active');
		});

		$(document).on('click', '.expand-selection-term', function(e){
			$('.archive-sidebar .term-container').toggleClass('active');
		});

		$(document).on('click', '.parent-backdrop .backdrop', function(){
			$('body, html').removeAttr('style');
			$(this).parent('.parent-backdrop').removeClass('show');
			setTimeout(function(){
				$(this).parent('.parent-backdrop').removeClass('animate');
			}, 300);
		});
  
			$("#term-accordion .card").on("show.bs.collapse hide.bs.collapse", function(e) {
				if (e.type=='show'){
					$(this).addClass('active');
				}else{
					$(this).removeClass('active');
				}
			});  
		

		function termAccordion(){
			if ($('#term-accordion .collapse-body').hasClass('show')){
				$('#term-accordion .card-header .btn-link').css('background-color', '#94c433');
			}
			else{
				$('#term-accordion .card-header .btn-link').css('background-color', '#256edb');
			}
		}
		
function gformsubmit() {

	$(document).on('click', '.gform-submit', function () {
		$('i.fa-spin').removeClass('d-none');
		$('.submit-text').css('padding-left', '5px').text('LOADING');
		
		// setTimeout(function(){
		// 	$('i.fa-spin').removeClass('d-none');
		// 	$('.submit-text').css('padding-left', '5px').text('LOADING');
		// }, 700);

	});
	$(document).on('load', '.gform-submit', function () {
		$('i.fa-spin').addClass('d-none');
		$('.submit-text').css('padding-left', '0').text('SUBMIT');
	});
}

$('.articles-slider').slick({
	dots: false,
	infinite: true,
	autoplay: true,
	autoplaySpeed: 3000,
	arrows: true,
	slidesToShow: 2,
	slidesToScroll: 1,
	adaptiveHeight: true,
  // centerMode: true,
	prevArrow : '<button type="button" class="slick-prev slick-controller fa fa-angle-left"></button>',
	nextArrow : '<button type="button" class="slick-next slick-controller fa fa-angle-right"></button>',
	responsive: [
		{
			breakpoint: 769,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
	]
});
$('.blog-slider').slick({
	dots: true,
	infinite: true,
	autoplay: true,
	autoplaySpeed: 3000,
	arrows: false,
	slidesToShow: 1,
	fade: true,
	slidesToScroll: 1,
	adaptiveHeight: true,
	customPaging : function(slider, i) {
		return '<div class="blog-dots"></div>';
	},
  // centerMode: true,
	responsive: [
		{
			breakpoint: 769,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
	]
});

$('.corporate-brands').slick({
	dots: false,
	infinite: true,
	autoplay: true,
	autoplaySpeed: 3000,
	arrows: true,
	slidesToShow: 4,
	slidesToScroll: 1,
	adaptiveHeight: true,
  // centerMode: true,
	prevArrow : '<button type="button" class="slick-prev slick-controller fa fa-angle-left"></button>',
	nextArrow : '<button type="button" class="slick-next slick-controller fa fa-angle-right"></button>',
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1,
			}
		},
		{
			breakpoint: 850,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			}
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
	]
});

$('.product-gallery-slide').slick({
	dots: false,
	infinite: true,
	autoplay: true,
	autoplaySpeed: 3000,
	arrows: true,
	slidesToShow: 3,
	slidesToScroll: 1,
	adaptiveHeight: true,
	prevArrow : '<button type="button" class="slick-prev slick-controller fa fa-angle-left"></button>',
	nextArrow : '<button type="button" class="slick-next slick-controller fa fa-angle-right"></button>',
	responsive: [
		{
			breakpoint: 1024,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
			}
		},
		{
			breakpoint: 850,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			}
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1
			}
		}
	]
});

$('.category-img-full').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	fade: true,
	infinite: false,
	adaptiveHeight: true,
	draggable: false,
	asNavFor: '.category-img-nav'
});
$('.category-img-nav').slick({
	slidesToShow: 5,
	slidesToScroll: 1,
	asNavFor: '.category-img-full',
	infinite: false,
	focusOnSelect: true,
	arrows: true,
	prevArrow: '<button type="button" class="slick-prev slick-controller fa fa-angle-left"></button>',
	nextArrow: '<button type="button" class="slick-next slick-controller fa fa-angle-right"></button>',
	responsive: [
		{
			breakpoint: 850,
			settings: {
				slidesToShow: 3,
				slidesToScroll: 1
			}
		},
		{
			breakpoint: 600,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1
			}
		}
	]
});

	});
});